import { render, staticRenderFns } from "./LearningStories.vue?vue&type=template&id=064c2bca&"
import script from "./LearningStories.vue?vue&type=script&lang=js&"
export * from "./LearningStories.vue?vue&type=script&lang=js&"
import style0 from "./LearningStories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports